import React, { useContext, useEffect, useState } from "react";
import styles from "./Login.module.css";
import "./toggle.css";
import { useNavigate } from "react-router-dom";
import AppContext from "../../store/AppContext";
import useHttp from "../../hook/use-http";
import { API_URL_MAIN } from "../../constants/driveglobalfilterinitalstates";
import getMobileOperatingSystem from "../../util/getMobileOperatingSystem";
import getOperatingSystem from "../../util/getOperatingSystem";
import * as $ from "jquery";
// import CryptoJS from "crypto-js";
import { Buffer } from "buffer";

function Login() {
  const [userid, setUserId] = useState("");
  const [pwd, setPwd] = useState("");
  const [evbus, setEv_Bus] = useState("FLEETEV");
  const [LoginError, setLoginError] = useState({});

  const filterHideShow = (txt) => {
    $(".justify-content-center").html("Fleet Ascent EV");
    setEv_Bus(txt);
  };

  const authctx = useContext(AppContext);
  const navigate = useNavigate();
  const { isLoading, error, sendReq: fetchData } = useHttp();

  function encodeToBase64(input) {
    return Buffer.from(input, "utf8").toString("base64");
  }

  useEffect(() => {
    if (authctx.username != "" && authctx.username != null) {
      navigate("/");
    }
  }, [authctx]);
  // console.log(authctx);

  useEffect(() => {
    const keyEnter = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        handlelogin();
      }
    };
    document.addEventListener("keydown", keyEnter);
    return () => {
      document.removeEventListener("keydown", keyEnter);
    };
  }, [userid, pwd]);

  const [userTypeBeforeLogin, setuserTypeBeforeLogin] = useState({ type: "" });

  const handlelogin = async () => {
    if (userid == "" || pwd == "") {
      setLoginError({ error: "INVALID_INPUT", message: "Please Enter Valid Credentials" });
      return;
    }

    try {
      let device_id = getMobileOperatingSystem();
      let os_sys = getOperatingSystem(window);
      // var encryptedData = CryptoJS.AES.encrypt(pwd, "nm3b52jk55n2rb2b2r").toString();
      // var encryptedData = btoa(pwd);
      var encryptedData = encodeToBase64(pwd);
      let requestBody = {
        username: userid,
        password: encryptedData,
        ev_bus: evbus,
        device_id,
        os_sys,
      };
      fetchData({ url: API_URL_MAIN + "auth/checkBeforeLogin", body: requestBody, }, appyDataBeforeLogin);
    } catch (err) {
      setLoginError(err);
    }
  };


  const [usernameTempHideShow, setUsernameTempHideShow] = useState(false)
  const [tempOrgData, setTempOrgData] = useState("")
  const appyDataBeforeLogin = (data) => {
    // return false;
    setTempOrgData(data.access_typeTemp) //1,2,3,4....
    if (data.hasOwnProperty("error")) {
      if (data.error == "unauthorized") {
        setLoginError({ message: data.message });
      } else if (data.error === "false") {

        alert(data.message);
      } else if (data.error === "success") {

        setuserTypeBeforeLogin(prev => ({ ...prev, type: data.data }));
      }
      // console.log("🔥 Backend sent:", data.data);
    } else {
      setLoginError({ message: "Something went wrong" });
    }
  };

  const [buttonManage, setButtonManage] = useState([])

  const vehicleTypes = ["ACE", "BUS", "ORION", "CORAL", "KRATOS"];

  const systems = {
    ERC: "ERC",
    FLEETEV: "FLEETEV",
  };


  const getUserVehicles = (userTypes, system) => {
    return vehicleTypes.filter((v) => userTypes.includes(`${system}_${v}`));
  };


  // useEffect(() => {
  //   if (!userTypeBeforeLogin) return;

  //   const split_str = tempOrgData.split(",");
  //   if (split_str.includes("111")) {
  //     setUsernameTempHideShow(true);
  //   }

  //   const userTypes = userTypeBeforeLogin.split(",");
  //   const system = evbus;

  //   const matchedVehicles = vehicleTypes.filter((vehicleType) =>
  //     userTypes.includes(`${system}_${vehicleType}`)
  //   );

  //   if (matchedVehicles.length > 1) {

  //     const buttonData = matchedVehicles.map((v) => ({
  //       id: `${system}_${v}`,
  //       label: v === "BUS" ? "CESL" : v,
  //     }));
  //     setButtonManage(buttonData);
  //     window.$("#LoginModal").modal("show");

  //   } else if (matchedVehicles.length === 1) {

  //     LoginWithType(`${system}_${matchedVehicles[0]}`);

  //   } else {

  //     setLoginError({ message: "Select Proper application Type" });
  //   }

  // }, [userTypeBeforeLogin, tempOrgData]);

  useEffect(() => {
    if (!userTypeBeforeLogin?.type) return;
    // ⛳ Username show/hide
    const split_str = tempOrgData.split(",");
    if (split_str.includes("111")) {
      setUsernameTempHideShow(true);
    }

    // 🔄 Parse user types
    const userTypes = userTypeBeforeLogin?.type?.split(",");
    const system = evbus; // Either "ERC" or "FLEETEV"

    const matchedVehicles = vehicleTypes.filter((v) =>
      userTypes.includes(`${system}_${v}`) 
    );
      // console.log("User types from backend:", userTypes);
      // console.log("Matched vehicles:", matchedVehicles); 

    if (matchedVehicles.length > 1) {
      const buttonData = matchedVehicles.map((v) => ({
        id: `${system}_${v}`,
        label: v === "BUS" ? "CESL" :
               v === "CORAL" ? "ACE PRO EV" :
               v === "KRATOS" ? "KRATOS" :
               v,
      }));
      setButtonManage(buttonData);
      window.$("#LoginModal").modal("show");
    } else if (matchedVehicles.length === 1) {
      // ➤ One match only — auto-login
      LoginWithType(`${system}_${matchedVehicles[0]}`);
    } else {
      setLoginError({ message: "Select Proper application Type" });
    }
  }, [userTypeBeforeLogin, tempOrgData]);


  // let ERC_ACE_CNT = 0;
  // let ERC_BUS_CNT = 0;
  // let ERC_ORION_CNT = 0;
  // let FLT_ACE_CNT = 0;
  // let FLT_BUS_CNT = 0;
  // let FLT_ORION_CNT = 0;

  // const [buttonManage, setButtonManage] = useState("")
  // useEffect(() => {
  //   // console.log("data", userTypeBeforeLogin);
  //   // return false
  //   if (userTypeBeforeLogin != "") {
  //     // code for button future hide/show
  //     var split_str = tempOrgData.split(",");
  //     if (split_str.indexOf("111") !== -1) {
  //       setUsernameTempHideShow(true)
  //     }
  //     // code for button future hide/show
  //     var arr = userTypeBeforeLogin.split(",");
  //     // console.log("arr", arr);
  //     // return false
  //     ERC_ACE_CNT = arr.includes("ERC_ACE") ? 1 : 0;
  //     ERC_BUS_CNT = arr.includes("ERC_BUS") ? 1 : 0;
  //     ERC_ORION_CNT = arr.includes("ERC_ORION") ? 1 : 0;
  //     FLT_ACE_CNT = arr.includes("FLEETEV_ACE") ? 1 : 0;
  //     FLT_BUS_CNT = arr.includes("FLEETEV_BUS") ? 1 : 0;
  //     FLT_ORION_CNT = arr.includes("FLEETEV_ORION") ? 1 : 0;

  //     if (evbus === "ERC") {
  //       if (ERC_ACE_CNT && ERC_BUS_CNT && ERC_ORION_CNT || ERC_ACE_CNT && ERC_BUS_CNT || ERC_BUS_CNT && ERC_ORION_CNT || ERC_ACE_CNT && ERC_ORION_CNT) {
  //         if (ERC_ACE_CNT && ERC_BUS_CNT && ERC_ORION_CNT) {
  //           setButtonManage("A_B_O");
  //         } else if (ERC_ACE_CNT && ERC_BUS_CNT) {
  //           setButtonManage("A_B");
  //         } else if (ERC_BUS_CNT && ERC_ORION_CNT) {
  //           setButtonManage("B_O");
  //         } else if (ERC_ACE_CNT && ERC_ORION_CNT) {
  //           setButtonManage("A_O");
  //         }
  //         window.$("#LoginModal").modal("show");
  //       } else if (ERC_ACE_CNT) {
  //         LoginWithType("ERC_ACE");
  //       } else if (ERC_BUS_CNT) {
  //         LoginWithType("ERC_BUS");
  //       } else if (ERC_ORION_CNT) {
  //         LoginWithType("ERC_ORION");
  //       } else {
  //         setLoginError({ message: "Select Proper application Type" });
  //       }
  //     } else {
  //       if (FLT_ACE_CNT && FLT_BUS_CNT && FLT_ORION_CNT || FLT_ACE_CNT && FLT_BUS_CNT || FLT_BUS_CNT && FLT_ORION_CNT || FLT_ACE_CNT && FLT_ORION_CNT) {
  //         if (FLT_ACE_CNT && FLT_BUS_CNT && FLT_ORION_CNT) {
  //           setButtonManage("A_B_O");
  //         } else if (FLT_ACE_CNT && FLT_BUS_CNT) {
  //           setButtonManage("A_B");
  //         } else if (FLT_BUS_CNT && FLT_ORION_CNT) {
  //           setButtonManage("B_O");
  //         } else if (FLT_ACE_CNT && FLT_ORION_CNT) {
  //           setButtonManage("A_O");
  //         }
  //         window.$("#LoginModal").modal("show");
  //       } else if (FLT_ACE_CNT) {
  //         LoginWithType("FLEETEV_ACE");
  //       } else if (FLT_BUS_CNT) {
  //         LoginWithType("FLEETEV_BUS");
  //       } else if (FLT_ORION_CNT) {
  //         LoginWithType("FLEETEV_ORION");
  //       } else {
  //         setLoginError({ message: "Select Proper application Type" });
  //       }
  //     }
  //   }
  // }, [userTypeBeforeLogin, tempOrgData]);

  const LoginWithType = async (ev_bus_type) => {
    let device_id = getMobileOperatingSystem();
    let os_sys = getOperatingSystem(window);
    // var encryptedData = CryptoJS.AES.encrypt(pwd, "nm3b52jk55n2rb2b2r").toString();
    var encryptedData = btoa(pwd);
    let requestBody = {
      username: userid,
      password: encryptedData,
      ev_bus: ev_bus_type,
      device_id,
      os_sys,
    };
    fetchData({ url: API_URL_MAIN + "auth", body: requestBody, }, appyDataLogin);
  };

  const appyDataLogin = (data) => {
    authctx.login_user(data);
  };

  const popUpButtonClicked = (e) => {
    window.$("#LoginModal").modal("hide");
    setEv_Bus(e.target.id);
    setwhichButton(e.target.id);
  };

  const [whichButton, setwhichButton] = useState("");
  useEffect(() => {
    if (whichButton != "") {
      doSomething();
    }
  }, [whichButton]);

  const doSomething = async () => {
    try {
      let device_id = getMobileOperatingSystem();
      let os_sys = getOperatingSystem(window);
      // var encryptedData = CryptoJS.AES.encrypt(pwd, "nm3b52jk55n2rb2b2r").toString();
      // var encryptedData = btoa(pwd);
      var encryptedData = encodeToBase64(pwd);
      let requestBody = {
        username: userid,
        password: encryptedData,
        ev_bus: whichButton,
        device_id,
        os_sys,
      };

      fetchData({ url: API_URL_MAIN + "auth", headers: { "Content-Type": "application/json", }, body: requestBody, }, appyDataLogin);
    } catch (err) {
      setLoginError(err);
    }
  };

  const changeuserId = (e) => {
    setLoginError({});
    setUserId(e.target.value);
  };
  const changepassword = (e) => {
    setLoginError({});
    setPwd(e.target.value);
  };

  var el = document.querySelectorAll(".togglebtn");
  for (let i = 0; i < el.length; i++) {
    el[i].onclick = function () {
      var c = 0;
      while (c < el.length) {
        el[c++].className = "togglebtn removed";
      }
      el[i].className = "togglebtn active";
    };
  }

  const onRadioChange = (e) => {
    // setuserTypeBeforeLogin("");
    setuserTypeBeforeLogin(prev => ({ ...prev, type: "" }));
    setLoginError({ message: "" });
    filterHideShow(e.target.value);
  };

  // const buttonConfig = {
  //   A_B_O: [
  //     { id: `${evbus}_ACE`, label: "ACE" },
  //     { id: `${evbus}_BUS`, label: "CESL" },
  //     { id: `${evbus}_ORION`, label: "ORION" },
  //   ],
  //   A_B: [
  //     { id: `${evbus}_ACE`, label: "ACE" },
  //     { id: `${evbus}_BUS`, label: "CESL" },
  //   ],
  //   B_O: [
  //     { id: `${evbus}_BUS`, label: "CESL" },
  //     { id: `${evbus}_ORION`, label: "ORION" },
  //   ],
  //   A_O: [
  //     { id: `${evbus}_ACE`, label: "ACE" },
  //     { id: `${evbus}_ORION`, label: "ORION" },
  //   ],
  // };

  return (
    <>
      <div className="modal fade" id="LoginModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-header" style={{ padding: "8px" }}>
              <h5 className="modal-title" id="exampleModalLabel">
                Select Project
              </h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" style={{ paddingTop: "20px" }} />
            </div>
            <div className="modal-body" style={{ padding: "8px" }}>
              {
                Array.isArray(buttonManage) &&
                buttonManage.map((btn, index) => (

                  <button
                    key={btn.id}
                    type="button"
                    onClick={popUpButtonClicked}
                    id={btn.id}
                    disabled={isLoading}
                    className={`btn btn-primary w-100 ${index > 0 ? "mt-1" : ""} ${styles["btn-primary"]} ${styles["btn"]}`}
                  >
                    {btn.label}
                  </button>

                  // <button key={btn.id} onClick={() => LoginWithType(btn.id)}>
                  //   {btn.label}
                  // </button>
                ))}
              {/* {buttonConfig[buttonManage]?.map(({ id, label }, index) => (
                <button
                  key={id}
                  type="button"
                  onClick={popUpButtonClicked}
                  id={id}
                  disabled={isLoading}
                  className={`btn btn-primary w-100 ${index > 0 ? "mt-1" : ""} ${styles["btn-primary"]} ${styles["btn"]}`}
                >
                  {label}
                </button>
              ))} */}
              {
                (usernameTempHideShow && evbus === "ERC") &&
                (
                  <>
                    {["JUPITER", "CYGNUS", "MAGNA", "INTERCITY", "CERUS"].map((label) => (
                      <button
                        key={label}
                        type="button"
                        className={`btn btn-primary w-100 mt-1 ${styles["btn-primary"]} ${styles["btn"]}`}
                      >
                        <img
                          src={process.env.PUBLIC_URL + "assets/work_in_progress_white.png"}
                          className={styles["work_in_progress_img"]}
                          alt={`${label} icon`}
                        />
                        <span>{label}</span>
                      </button>
                    ))}
                  </>
                  // <>
                  // <button type="button" className={`btn btn-primary w-100 mt-1 ${styles["btn-primary"]} ${styles["btn"]}`}>
                  //   <img src={process.env.PUBLIC_URL + "assets/work_in_progress_white.png"} className={`${styles["work_in_progress_img"]}`} />
                  //   <span>CORAL</span>
                  // </button>
                  // <button type="button" className={`btn btn-primary w-100 mt-1 ${styles["btn-primary"]} ${styles["btn"]}`}>
                  //   <img src={process.env.PUBLIC_URL + "assets/work_in_progress_white.png"} className={`${styles["work_in_progress_img"]}`} />
                  //   <span>JUPITER</span>
                  // </button>
                  // <button type="button" className={`btn btn-primary w-100 mt-1 ${styles["btn-primary"]} ${styles["btn"]}`}>
                  //   <img src={process.env.PUBLIC_URL + "assets/work_in_progress_white.png"} className={`${styles["work_in_progress_img"]}`} />
                  //   <span>KRATOS</span>
                  // </button>
                  // <button type="button" className={`btn btn-primary w-100 mt-1 ${styles["btn-primary"]} ${styles["btn"]}`}>
                  //   <img src={process.env.PUBLIC_URL + "assets/work_in_progress_white.png"} className={`${styles["work_in_progress_img"]}`} />
                  //   <span>CYGNUS</span>
                  // </button>
                  // <button type="button" className={`btn btn-primary w-100 mt-1 ${styles["btn-primary"]} ${styles["btn"]}`}>
                  //   <img src={process.env.PUBLIC_URL + "assets/work_in_progress_white.png"} className={`${styles["work_in_progress_img"]}`} />
                  //   <span>MAGNA</span>
                  // </button>
                  // <button type="button" className={`btn btn-primary w-100 mt-1 ${styles["btn-primary"]} ${styles["btn"]}`}>
                  //   <img src={process.env.PUBLIC_URL + "assets/work_in_progress_white.png"} className={`${styles["work_in_progress_img"]}`} />
                  //   <span>INTERCITY</span>
                  // </button>
                  // <button type="button" className={`btn btn-primary w-100 mt-1 ${styles["btn-primary"]} ${styles["btn"]}`}>
                  //   <img src={process.env.PUBLIC_URL + "assets/work_in_progress_white.png"} className={`${styles["work_in_progress_img"]}`} />
                  //   <span>CERUS</span>
                  // </button></>
                )

              }
            </div>
          </div>
        </div>
      </div>

      <div className={styles.background}>
        <header className=" p-3">
          <div className="d-flex justify-content-between ">
            <div className="p-2 bd-highlight" style={{ position: 'relative' }}>
              <img src={process.env.PUBLIC_URL + "assets/img/tml_wt.png"} className={`img-fluid ${styles.ttlLogo}`} />
              <br />
              <img src={process.env.PUBLIC_URL + "assets/img/only_for_tml.png"} className={`img-fluid ${styles.nly_fo_tml}`} style={{ position: 'absolute' }} />
            </div>
            <div className="p-2 bd-highlight">
              <img src={process.env.PUBLIC_URL + "assets/img/sparqplug_logo.png"} className={`img-fluid ${styles.spargPlgLogo}`} />
            </div>
          </div>
        </header>

        <div className="col-md-10 col-sm-10 col-lg-10" style={{ textAlign: "end", marginLeft: "3%" }} >
          <div className="form-check form-check-inline">
            <input className="form-check-input" type="radio" name="inlineRadioOptions" id="ERC" value="ERC" checked={evbus === "ERC"} onChange={onRadioChange} />
            <label className="form-check-label" style={{ color: "white" }} htmlFor="inlineRadio1" >
              Engineering
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input className="form-check-input" type="radio" name="inlineRadioOptions" id="FLEETEV" value="FLEETEV" checked={evbus === "FLEETEV"} onChange={onRadioChange} />
            <label className="form-check-label" style={{ color: "white" }} htmlFor="inlineRadio2" >
              Ascents EV
            </label>
          </div>
        </div>

        <section className={` d-flex justify-content-end p-3 ${styles.loginhold}`} >
          <div className={` p-4 col-md-4 ${styles.loginSec}`}>
            <h1 className="mb-4 d-flex justify-content-center" id="button">
              Fleet Ascent EV
            </h1>
            {
              // LoginError.message != "" ? (
              //   <h3 className={`${styles.error}`}> {LoginError.message} </h3>
              // )

              error != "" ? (
                <h3 className={`${styles.error}`}> {error} </h3>
              )
                : (
                  ""
                )}

            <div className="mb-4">
              <input type="email" className="form-control" onChange={changeuserId} placeholder="Enter User Name" autoComplete="off" />
            </div>
            <div className="mb-4">
              <input type="password" className="form-control" onChange={changepassword} placeholder="Enter your password" autoComplete="off" />
            </div>
            <button type="button" onClick={handlelogin} disabled={isLoading} className={`btn btn-primary w-100 ${styles["btn-primary"]} ${styles["btn"]}`} >
              Login
            </button>
          </div>
        </section>
      </div >
    </>
  );
}

export default Login;
